import {
    Route,
    Routes,
    Navigate,
    useLocation,
} from "react-router-dom";
import { DtoRoutesDefinition } from "../dto/routes.dto";
import { isAuthenticated } from "../redux/authSlice";
import { useAppSelector, useAppDispatch } from "../redux/hooks";
import Login from "../../components/Login/Login";
import Agentlist from "../../components/AgentComponents/Agentlist";
import CreateAgent from "../../components/AgentComponents/CreateAgent";
import EditAgent from "../../components/AgentComponents/EditAgent";
import CreateLocation from "../../components/LocationComponents/CreateLocation";
import ResetPassword from "../../components/Login/ResetPassword";
import SetPassword from "../../components/Login/Setpassword";
import CreateKiosk from "../../components/KioskComponents/CreateKiosk";
import LocationList from "../../components/LocationComponents/LocationList";
import EditLocation from "../../components/LocationComponents/EditLocation";
import EditKiosk from "../../components/KioskComponents/EditKiosk";
import KioskList from "../../components/KioskComponents/KioskList";
import EditSettings from "../../components/Settings/EditSettings";
import Settings from "../../components/Settings/SettingsView";
import Dashboard from "../../components/DashboardComponents/Dashboard";
import Teams from "../../components/Teams/Teams";
import KioskVideoRoom from "../../components/KioskVideoRoom/KioskVideoRoom";
import constant from "../constant";
import ReportDetails from "../../components/Reports/Reportdetails";
import { showToaster } from "../../core/redux/toastSlice";
import VideoCallHandOffRoom from "../../components/DashboardComponents/VideoCallHandOffRoom";
import DeviceChoice from "../../components/Settings/DeviceChoice";
import QrRoom from "../../components/DashboardComponents/QrRoom";
import VoiceMailReports from "../../components/VoiceMailReports/VoiceMailReports";
import VoiceMailRecording from "../../components/VoiceMailReports/VoiceMailRecording";

const OpenRoutes: DtoRoutesDefinition[] = [
    // {path: 'not-found', element: <NotFound />},
    { path: "kiosk-video", element: <KioskVideoRoom /> },
    {
        path: "/call/:id?",
        element: <VideoCallHandOffRoom />,
    },
    {
        path: "/tenantRoom/:locationId?",
        element: <QrRoom />,
    },
    {
        path: "/voiceMailRecording/:callSid?",
        element: <VoiceMailRecording />,
    },
];

const ProtectedRoutes: DtoRoutesDefinition[] = [
    {
        path: "/",
        element: <></>,
        redirectTo:
            process.env.REACT_APP_AGENT !== localStorage.getItem("event")
                ? constant.AGENT_LIST
                : "/dashboard",
    },
    {
        path: constant.AGENT_LIST,
        element: <Agentlist />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.AGENT_CREATE,
        element: <CreateAgent />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.AGENT_EDIT,
        element: <CreateAgent />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.LOCATION_LIST,
        element: <LocationList />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.LOCATION_EDIT,
        element: <EditLocation />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: "/editagent",
        element: <EditAgent />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.SETTING_EDIT,
        element: <EditSettings />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.SETTING,
        element: <Settings />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.ADMIN_REPORT,
        element: <ReportDetails />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: "/dashboard",
        element: <Dashboard />,
        event: process.env.REACT_APP_AGENT,
    },
    {
        path: "/team",
        element: <Teams />,
        event: process.env.REACT_APP_AGENT,
    },
    {
        path: constant.AGENT_REPORT,
        element: <ReportDetails />,
        event: process.env.REACT_APP_AGENT,
    },
    {
        path: constant.VOICEMAIL_REPORT,
        element: <VoiceMailReports />,
        event: process.env.REACT_APP_AGENT,
    },
    {
        path: constant.ADMIN_VOICEMAIL_REPORT,
        element: <VoiceMailReports />,
        event: process.env.REACT_APP_ADMIN,
    },
    // {
    //     path: "/voiceMailRecording/:callSid?",
    //     element: <VoiceMailRecording />,
    //     event: process.env.REACT_APP_AGENT,
    // },
    // {
    //     path: "/voiceMailRecording/:callSid?",
    //     element: <VoiceMailRecording />,
    //     event: process.env.REACT_APP_ADMIN,
    // }
];

const AuthRoutes: DtoRoutesDefinition[] = [
    { path: "/sign-in", element: <Login /> },
    { path: "/resetpassword", element: <ResetPassword /> },
    { path: "/setpassword", element: <SetPassword /> },
    { path: "/set-password", element: <SetPassword /> },
];

const CustomizedRoutes: DtoRoutesDefinition[] = [
    {
        path: constant.LOCATION_CREATE,
        element: <CreateLocation />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.KIOSK_LIST,
        element: <KioskList />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.KIOSK_CREATE,
        element: <CreateKiosk />,
        event: process.env.REACT_APP_ADMIN,
    },
    {
        path: constant.KIOSK_EDIT,
        element: <CreateKiosk />,
        event: process.env.REACT_APP_ADMIN,
    },
];

const UnAuthRouteMiddleware = () => {
    const location = useLocation();
    const navState: { [index: string]: string } = {};
    let previousPathName = location.pathname;
    if (location.search && previousPathName === "/location/create") {
        previousPathName = location.pathname + location.search;
        navState['lc_redirect'] = previousPathName;
    }
    return (
        <Navigate
            to="/sign-in"
            state={navState}
            replace
        />
    );
};

const AuthRouteMiddleware = () => {
    let redirectUrl =
        process.env.REACT_APP_ADMIN === localStorage.getItem("event")
            ? constant.AGENT_LIST
            : "/dashboard";
    const location = useLocation();
    if (
        process.env.REACT_APP_ADMIN === localStorage.getItem("event") &&
        location.state &&
        location.state.lc_redirect
    ) {
        redirectUrl = location.state.lc_redirect;
    }
    return (
        <Navigate
            to={redirectUrl}
            state={{ locationFrom: location.pathname }}
        />
    );
};

const ProtectedRouteMiddleware = (routeDefinition: {
    routeInfo: DtoRoutesDefinition;
}) => {
    const location = useLocation();
    if (routeDefinition.routeInfo.redirectTo) {
        return (
            <Navigate
                to={routeDefinition.routeInfo.redirectTo!}
                state={{ locationFrom: location.pathname }}
            />
        );
    }
    if (
        routeDefinition.routeInfo.event === undefined ||
        (routeDefinition.routeInfo.event &&
            routeDefinition.routeInfo.event === localStorage.getItem("event"))
    ) {
        return routeDefinition.routeInfo.element;
    }
    return <AuthRouteMiddleware />;
};

const CustomizedRouteMiddleware = (routeDefinition: {
    routeInfo: DtoRoutesDefinition;
}) => {
    let LoginUserDetails = useAppSelector((state) => state.auth.users);
    const dispatch = useAppDispatch();
    if (
        routeDefinition.routeInfo.event &&
        routeDefinition.routeInfo.event === localStorage.getItem("event") &&
        LoginUserDetails.role === "super_admin"
    ) {
        return routeDefinition.routeInfo.element;
    }
    dispatch(
        showToaster({
            dialogBgColor: "bg-danger",
            dialogMsg: "You are not authorized to access this page!",
            showDialog: true,
            timer: "5000",
        })
    );
    return <AuthRouteMiddleware />;
};

export const AppRoutes = () => {
    const authenticated = useAppSelector(isAuthenticated);
    return (
        <Routes>
            {OpenRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={routeInfo.element}
                />
            ))}
            {ProtectedRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={
                        authenticated ? (
                            <ProtectedRouteMiddleware routeInfo={routeInfo} />
                        ) : (
                            <UnAuthRouteMiddleware />
                        )
                    }
                />
            ))}

            {CustomizedRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={
                        authenticated ? (
                            <CustomizedRouteMiddleware routeInfo={routeInfo} />
                        ) : (
                            <UnAuthRouteMiddleware />
                        )
                    }
                />
            ))}

            {AuthRoutes.map((routeInfo) => (
                <Route
                    key={routeInfo.path}
                    path={routeInfo.path}
                    element={
                        !authenticated ? (
                            routeInfo.element
                        ) : (
                            <AuthRouteMiddleware />
                        )
                    }
                />
            ))}
            <Route
                path="*"
                element={
                    <Navigate
                        replace
                        to={
                            process.env.REACT_APP_ADMIN ===
                                localStorage.getItem("event")
                                ? constant.AGENT_LIST
                                : "/dashboard"
                        }
                    />
                }
            />
        </Routes>
    );
};
